import {
  fetchMailAccountSettings,
  saveMailAccountSignature,
} from "@/lib/api/accountSettings";
import { readAccountSettings, writeAccountSettings } from "@/lib/mail/accountSettingsPrefs";
import type { MailAccountSummary } from "@/lib/types/mail";

/** Synchronise les signatures compte ↔ serveur (source de vérité serveur si définie). */
export async function syncAccountSignatures(
  accounts: MailAccountSummary[]
): Promise<boolean> {
  if (accounts.length === 0) return false;

  const res = await fetchMailAccountSettings();
  if (!res.ok) return false;

  let changed = false;
  const byId = new Map(
    (res.data.settings ?? []).map((entry) => [entry.accountId, entry.signature ?? ""])
  );

  for (const account of accounts) {
    const serverSignature = byId.get(account.id) ?? "";
    const localSignature = readAccountSettings(account.id).signature;

    if (serverSignature.trim()) {
      if (localSignature !== serverSignature) {
        writeAccountSettings(account.id, { signature: serverSignature });
        changed = true;
      }
      continue;
    }

    if (localSignature.trim()) {
      const push = await saveMailAccountSignature(account.id, localSignature);
      if (push.ok) changed = true;
    }
  }

  return changed;
}
